import { API_URLS } from '../constants';

interface EnhanceResponse {
  status: 'success' | 'error';
  data?: {
    prompt: string;
    run_id: string;
  };
  message?: string;
  error_code?: string;
  details?: {
    detail: string;
  };
}

export async function enhancePrompt(promptText: string): Promise<string> {
  try {
    const response = await fetch(API_URLS.AGENT.ENHANCE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        prompt: promptText
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data: EnhanceResponse = await response.json();
    
    if (data.status === 'success' && data.data?.prompt) {
      return data.data.prompt;
    } else {
      throw new Error(data.message || 'Enhancement failed');
    }
  } catch (error) {
    console.error('Failed to enhance prompt:', error);
    throw error;
  }
}
